import makeAsync from "../../utils/makeAsync"

export default makeAsync(
  () =>
    import(
      /* webpackChunkName: "async/helpCenterWidget" */ "../../scenes/HelpCenter/scenes/Widget/Widget"
    ),
  {
    lazy: true,
  },
)
